// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1HRyA","noInteraction":"EventWrapper_noInteraction__UZEb3","pointerPassthrough":"EventWrapper_pointerPassthrough__3FFDP"};